import { Axios, AxiosResponse } from "axios"
import Notify from 'quasar/src/plugins/Notify.js';
import { DevLog } from "@/helpers/consoleHelpers"
import { redirectToRenewIfPossible } from "@/helpers/routerHelpers"
import { getAuthenticationStore, getCommonStore } from "@/helpers/storeHelpers"

import router from "@/router"

const excludeNotifyRoutes = [
    "login-main",
    "recover-password",
    "recover-password-phone",
    "recover-password-email",
    "create-account-msisdn"
]

export const AxiosInterceptorsResponse = (MyAxios: Axios) => {
    MyAxios.interceptors.response.use(function (response:AxiosResponse) {
        const commonStore = getCommonStore()
        if (commonStore) {
            commonStore.stopLoading()
            commonStore.requestLoading = false
        }

        return response;
    }, function (error) { 
        const originalConfig = error.config;
        if (error.code && error.code === 'ERR_NETWORK') {
            return Promise.reject(error);
        } else if (router && error.response.status == 401 && !originalConfig.ignoreUnauthorizedBehavior && !originalConfig.url.match(/(.*\/users\/login)/)) {
            // If you get a 401 it means you're not correctly authenticated.
            // Redirect to unlock with PIN and if no refresh_token => login.
            const authStore = getAuthenticationStore()
            const redirectTo = redirectToRenewIfPossible({ fallBackToLogin: true }, authStore)
            if (redirectTo && router?.currentRoute.value.name?.toString() !== redirectTo.name) {
                if (authStore) {
                    authStore.logout(redirectTo.name !== 'login-main')
                }

                router.push(redirectTo)
            } else {
                return Promise.reject(error);
            }
        } else if (error.response.status === 503) {
            // In case of a maintenance.
            router.push({ name: 'maintenance' });
        } else {
            if (!originalConfig.ignoreGlobalError && !excludeNotifyRoutes.includes(router.currentRoute.value.name?.toString() ?? '')) {
                // Unless you set ignoreGlobalError to true or if the route isn't excluded
                // we use the Notify plugin to show an error message.
                let message = error.response ? error.response.data.error : error.message;
                if (typeof message === 'object') {
                    if (message.type && typeof message.type === 'string' && message.type.match(/(.*)api\.transatel\.com(.*)/)) {
                        message = message.detail
                    }
                }

                // Create the toast.
                Notify.create({
                    type: 'negative',
                    message: `MESSAGE: ${message} <br/> CODE: ${error.code}`,
                    position: 'top-right',
                    html: true,
                    progress: true
                })
            }
            if (['CanceledError', 'AbortError'].includes(error.name)) {
                // If the request has been aborted or canceled.
                // Only log if we're in development or local.
                DevLog.log("Request aborted")
            }

            return Promise.reject(error);
        }
    });

    return MyAxios;
}